<script setup lang="ts">
import type { OverviewFrequency, OverviewGroup } from '../models/overview.types'

import type { SelectOption } from '@/shared/ui'
import { MultiSelect, Select, Switch } from '@/shared/ui'

defineProps<{
  groupOptions: SelectOption<OverviewGroup>[]
  frequencyOptions: SelectOption<OverviewFrequency>[]
  campaignOptions: SelectOption<string>[]
  channelOptions: SelectOption<string>[]
  hasForecast: boolean
  groupLabel: string
  frequencyLabel: string
  campaignLabel: string
  channelLabel: string
  forecastLabel: string
}>()

const group = defineModel<OverviewGroup>('group', { required: true })
const frequency = defineModel<OverviewFrequency>('frequency', { required: true })
const campaign = defineModel<string | null>('campaign', { default: null })
const channels = defineModel<string[]>('channels', { default: () => [] })
const forecast = defineModel<boolean>('forecast', { default: false })
</script>

<template>
  <div
    class="summary-overview-controls my-sm flex w-full flex-wrap items-center justify-between gap-3"
  >
    <div class="summary-overview-controls__primary flex flex-wrap items-center gap-3 max-md:w-full">
      <div class="summary-overview-controls__select relative w-40">
        <Select v-model="group" :options="groupOptions" :label="groupLabel" size="sm" />
      </div>
      <div class="summary-overview-controls__select relative w-40">
        <Select v-model="frequency" :options="frequencyOptions" :label="frequencyLabel" size="sm" />
      </div>
    </div>

    <div
      class="summary-overview-controls__secondary flex flex-wrap items-center gap-3 max-md:w-full"
    >
      <div
        v-if="group === 'campaign_group'"
        class="summary-overview-controls__select relative w-40"
      >
        <Select v-model="campaign" :options="campaignOptions" :label="campaignLabel" size="sm" />
      </div>
      <div
        v-else-if="group === 'marketing_channel'"
        class="summary-overview-controls__channels relative w-56"
      >
        <MultiSelect
          v-model="channels"
          :options="channelOptions"
          :label="channelLabel"
          size="sm"
          :max-visible-chips="1"
        />
      </div>
      <Switch v-if="hasForecast" v-model="forecast" :label="forecastLabel" size="sm" />
    </div>
  </div>
</template>
